import { useFormContext } from 'react-hook-form';
import { ReactComponent as InfoCircle } from 'assets/images/InfoCircle.svg?react';
import RootInput from 'components/Input/RootInput/RootInput';
import { type RootInputProps } from 'components/Input/RootInput/types';
import {
  TOTAL_MONTH_INCOME_MAX_LENGTH,
  TOTAL_MONTHLY_INCOME_MASK_OPTIONS,
  TOTAL_MONTHLY_INCOME_TOOLTIP_MESSAGE,
} from './config';

type Props = Pick<RootInputProps, 'name' | 'label' | 'required' | 'containerClassName'>;

const TotalMonthlyIncomeInput = (props: Props) => {
  const { name, label, containerClassName, required } = props;

  const { control, clearErrors, setError } = useFormContext();

  return (
    <RootInput
      key="totalMonthlyIncome"
      name={name}
      label={label}
      control={control}
      clearErrors={clearErrors}
      tooltipText={TOTAL_MONTHLY_INCOME_TOOLTIP_MESSAGE}
      setError={setError}
      onChangeResetTooltip
      containerClassName={containerClassName}
      required={required}
      inputMode="numeric"
      maskOptions={TOTAL_MONTHLY_INCOME_MASK_OPTIONS}
      maxLength={TOTAL_MONTH_INCOME_MAX_LENGTH}
      icon={<InfoCircle role="none" />}
      spellCheck={false}
    />
  );
};

export default TotalMonthlyIncomeInput;
